import React from 'react'
import { NavigateFn } from '@reach/router'
import useBuildingSearch from './hooks/useBuildingSearch'
import { Tag, Intent } from '@blueprintjs/core'
import { Flex, HighlightedText, SearchDropdown } from '@ui'
import { BMTableBuilding } from '@api'
import track from '@track'
import Event from '@track/Event'
import css from './buildingManagement.module.scss'

export default function BuildingSearch({
  navigate,
  queryTable,
  includeOld,
}: {
  navigate?: NavigateFn
  queryTable: (query: string) => void
  includeOld: boolean
}) {
  const search = useBuildingSearch(includeOld)

  const renderItem = (building: BMTableBuilding) => {
    return <Building building={building} />
  }

  const onSelect = (building: BMTableBuilding) => {
    navigate?.(`?buildingId=${building.id}`)
    track.buildings({
      eventName: Event.SEARCH_RESULT_CLICK,
    })
  }

  return (
    <div>
      <SearchDropdown
        {...{
          search,
          onSelect,
          queryTable,
          renderItem,
          width: '400',
        }}
      />
    </div>
  )
}

function Building({ building, query }: { building: BMTableBuilding; query?: string }) {
  const name = <HighlightedText text={building.name} query={query} />

  let address
  if (building.address) {
    address = <HighlightedText text={building.address} query={query} />
  }
  return (
    <Flex align="center" justify="space-between" style={{ width: 400 }}>
      <div style={{ maxWidth: 320 }}>
        <span
          style={{
            maxWidth: 320,
            textOverflow: 'ellipsis',
            wordBreak: 'break-word',
          }}
        >
          {name}
        </span>
        {address && (
          <div>
            <div className={css.small} style={{ fontSize: 12 }}>
              {address}
            </div>
          </div>
        )}
      </div>
      <Tag minimal intent={Intent.WARNING}>
        Building
      </Tag>
    </Flex>
  )
}
